// TODO(real-data): replace with /metrics endpoint when backend exposes it (HEALTH-01 v1.x)
//
// STATS-01 ships values verbatim from the design reference (per Phase 3 D-06).
// Real numbers land when backend exposes a /metrics summary endpoint.
//
// Per D-07, the values themselves come through i18n keys, so locale-specific
// formatting (e.g., MKD numerals if ever needed) flows naturally.

import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { motion, useReducedMotion } from 'motion/react';

const SLABS = ['markets', 'openInterest', 'traders', 'settlement'] as const;

export default function Stats(): JSX.Element {
  const { t } = useTranslation();
  const reduce = useReducedMotion();

  return (
    <section className="border-ink bg-ink text-paper border-b py-20">
      <motion.div
        initial={reduce ? false : { opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-100px' }}
        transition={reduce ? { duration: 0 } : { duration: 0.5 }}
        className="mx-auto grid max-w-[1240px] grid-cols-2 gap-8 px-6 md:grid-cols-4"
      >
        {SLABS.map((key, idx) => (
          <motion.div
            key={key}
            initial={reduce ? false : { opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={reduce ? { duration: 0 } : { duration: 0.5, delay: idx * 0.1 }}
            className="flex flex-col gap-2"
          >
            <div className="text-orange font-mono text-[clamp(40px,5vw,64px)] leading-none font-bold tracking-[-0.02em]">
              {t(`stats.${key}.value`)}
            </div>
            <div className="font-mono text-[11px] tracking-[0.18em] uppercase opacity-70">
              {t(`stats.${key}.label`)}
            </div>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
}
